import { render, staticRenderFns } from "./zjxxdjbcjds.vue?vue&type=template&id=1963e58c&scoped=true&"
import script from "./zjxxdjbcjds.vue?vue&type=script&lang=js&"
export * from "./zjxxdjbcjds.vue?vue&type=script&lang=js&"
import style0 from "./zjxxdjbcjds.vue?vue&type=style&index=0&id=1963e58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963e58c",
  null
  
)

export default component.exports